import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    theme
  } = useTheme();
  const investorLoginUrl = 'https://adfs4.sts.altareturn.com/adfs/ls/?wa=wsignin1.0&wtrealm=urn%3aportal%3aracecapital&wctx=https%3a%2f%2fracecapital.altareturn.com%2f_layouts%2f15%2fAuthenticate.aspx%3fSource%3d%252F&wreply=https%3a%2f%2fracecapital.altareturn.com%2f_trust%2fdefault.aspx';
  return <nav className="w-full py-4 px-6 md:px-12 bg-white border-b border-gray-100 transition-colors" data-id="element-47">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-48">
        <div className="flex items-center" data-id="element-49">
          <Logo data-id="element-50" />
        </div>
        <div className="hidden md:flex items-center space-x-8" data-id="element-51">
          <NavLink to="/how-we-invest" data-id="element-52">HOW WE INVEST</NavLink>
          <NavLink to="/portfolio" data-id="element-53">PORTFOLIO</NavLink>
          <NavLink to="/team" data-id="element-54">TEAM</NavLink>
          <a href={investorLoginUrl} target="_blank" rel="noopener noreferrer" className="text-[#070707] hover:text-red-600 font-medium text-sm transition-colors" data-id="element-55">
            INVESTOR LOGIN
          </a>
          <button className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-6 rounded-md transition-colors" data-id="element-56">
            PITCH US
          </button>
        </div>
        <div className="md:hidden flex items-center" data-id="element-57">
          <button className="text-[#070707]" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-58">
            {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-59" /> : <MenuIcon className="h-6 w-6" data-id="element-60" />}
          </button>
        </div>
      </div>
      {/* Mobile menu */}
      {mobileMenuOpen && <div className="md:hidden mt-4 pb-4" data-id="element-61">
          <div className="flex flex-col space-y-4" data-id="element-62">
            <MobileNavLink to="/how-we-invest" onClick={() => setMobileMenuOpen(false)} data-id="element-63">
              HOW WE INVEST
            </MobileNavLink>
            <MobileNavLink to="/portfolio" onClick={() => setMobileMenuOpen(false)} data-id="element-64">
              PORTFOLIO
            </MobileNavLink>
            <MobileNavLink to="/team" onClick={() => setMobileMenuOpen(false)} data-id="element-65">
              TEAM
            </MobileNavLink>
            <a href={investorLoginUrl} target="_blank" rel="noopener noreferrer" className="text-[#070707] hover:text-red-600 font-medium text-sm transition-colors block px-4 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-66">
              INVESTOR LOGIN
            </a>
            <button className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-6 rounded-md transition-colors w-full" data-id="element-67">
              PITCH US
            </button>
          </div>
        </div>}
    </nav>;
};
const Logo = () => {
  return <Link to="/" className="flex items-center" data-id="element-68">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9QqUfvRDGwG7W9qysjtvXP/RC-Logo_01-PositiveRGB.png" alt="Race Capital Logo" className="h-10" data-id="element-69" />
    </Link>;
};
const NavLink = ({
  to,
  children,
  className = ''
}) => <Link to={to} className={`text-[#070707] hover:text-red-600 font-medium text-sm transition-colors ${className}`} data-id="element-70">
    {children}
  </Link>;
const MobileNavLink = ({
  to,
  children,
  onClick
}) => <Link to={to} className="text-[#070707] hover:text-red-600 font-medium text-sm transition-colors block px-4 py-2" onClick={onClick} data-id="element-71">
    {children}
  </Link>;